// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nodeWarning{position:fixed;z-index:99999999;top:0;transition:all 0.2s ease;opacity:0;transform:translateY(15px);pointer-events:none;max-width:235px;line-height:1.4}.nodeWarning.active{opacity:1;transform:translateY(0px)}.nodeWarning::after{content:'';position:absolute;top:100%;left:0;right:0;margin:0 auto;width:0;height:0;border-top:solid 9px #464646;border-left:solid 9px transparent;border-right:solid 9px transparent}\n", ""]);
// Exports
module.exports = exports;
